<ng-container *ngIf="historyItem">
  <button
    class="warn transparent"
    *ngIf="!isMoreOption"
    mat-flat-button
    [class.waiting]="waiting"
    (click)="openCertificate(historyItem.urlCertificate)">
    <span class="odilo-icon certificateButtonItem" aria-hidden="true">i_certificate</span>
    <ng-container *ngIf="!waiting"> {{ 'button.certificate' | translate }} </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>

  <button
    mat-menu-item
    *ngIf="isMoreOption && historyItem.record.learningExperienceId && historyItem.urlCertificate"
    (click)="openCertificate(historyItem.urlCertificate)">
    <span class="odilo-icon" aria-hidden="true">download</span>
    {{ 'button.download.certificate' | translate }}
  </button>
</ng-container>

<ng-container *ngIf="certificateUrl">
  <button
    class="warn transparent"
    *ngIf="!isMoreOption"
    mat-flat-button
    [class.waiting]="waiting"
    (click)="openCertificate(certificateUrl)">
    <span class="odilo-icon certificateButtonItem" aria-hidden="true">i_certificate</span>
    <ng-container *ngIf="!waiting"> {{ 'button.certificate' | translate }} </ng-container>

    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>

  <button mat-menu-item *ngIf="isMoreOption && certificateUrl" (click)="openCertificate(certificateUrl)">
    <span class="odilo-icon" aria-hidden="true">download</span>
    {{ 'button.download.certificate' | translate }}
  </button>
</ng-container>
